import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { ImageList, ImageListItem, useMediaQuery } from "@mui/material";

const galleryImages = [
  "166.jpg",
  "165.jpg",
  "164.jpg",
  "163.jpg",
  "162.jpg",
  "161.jpg",
  "160.jpg",
  "159.jpg",
  "158.jpg",
  "157.jpg",
  "156.jpg",
  "155.jpg",
  "154.jpg",
  "153.jpg",
  "152.jpg",
  "151.jpg",
  "150.jpg",
  "149.jpg",
  "148.jpg",
  "147.jpg",
  "146.jpg",
  "145.jpg",
  "144.jpg",
  "143.jpg",
  "142.jpg",
  "141.jpg",
  "140.jpg",
  "139.jpeg",
  "138.jpeg",
  "137.jpg",
  "136.jpeg",
  "135.jpeg",
  "134.jpg",
  "133.jpeg",
  "132.jpg",
  "131.jpg",
  "130.jpg",
  "129.jpeg",
  "128.jpeg",
  "127.jpg",
  "126.jpg",
  "125.jpg",
  "124.jpeg",
  "123.jpg",
  "122.jpg",
  "121.jpg",
  "120.JPG",
  "119.jpg",
  "118.jpeg",
  "117.jpg",
  "116.jpg",
  "115.jpg",
  "114.jpg",
  "113.jpg",
  "112.jpg",
  "111.jpg",
  "110.jpg",
  "109.jpg",
  "108.jpg",
  "106.jpg",
  "105.jpg",
  "104.jpeg",
  "103.jpg",
  "102.jpeg",
  "101.jpg",
  "100.jpg",
  "99.jpg",
  "98.jpg",
  "97.jpg",
  "96.jpg",
  "95.jpg",
  "94.jpg",
  "93.jpeg",
  "92.jpg",
  "91.jpg",
  "90.jpg",
  "89.jpg",
  "88.jpeg",
  "87.jpg",
  "86.jpeg",
  "85.jpg",
  "84.jpg",
  "83.jpg",
  "82.jpg",
  "81.jpg",
  "80.jpg",
  "79.jpg",
  "78.JPG",
  "77.jpg",
  "76.jpg",
  "75.jpg",
  "74.jpg",
  "73.jpg",
  "72.JPG",
  "71.jpg",
  "70.jpg",
  "69.JPG",
  "68.jpg",
  "67.jpg",
  "66.png",
  "65.jpg",
  "64.png",
  "63.jpg",
  "62.jpg",
  "61.jpg",
  "60.jpg",
  "59.JPG",
  "58.jpg",
  "57.jpg",
  "56.jpg",
  "55.jpg",
  "54.jpg",
  "53.jpg",
  "52.jpg",
  "51.jpg",
  "50.png",
  "49.jpg",
  "48.jpg",
  "47.png",
  "46.png",
  "45.png",
  "44.png",
  "43.jpg",
  "42.jpg",
  "41.jpg",
  "40.png",
  "39.png",
  "38.jpg",
  "37.jpg",
  "36.png",
  "35.jpg",
  "34.jpg",
  "33.jpg",
  "32.jpg",
  "31.jpg",
  "30.jpg",
  "29.jpg",
  "28.jpg",
  "27.jpg",
  "26.jpg",
  "25.jpg",
  "24.jpg",
  "23.jpg",
  "22.jpg",
  "21.jpg",
  "20.jpg",
  "19.jpg",
  "18.jpg",
  "17.jpg",
  "16.jpg",
  "15.jpg",
  "14.jpg",
  "13.jpg",
  "12.jpg",
  "11.jpg",
  "10.jpg",
  "9.jpg",
  "8.jpg",
  "7.jpg",
  "6.jpg",
  "5.jpg",
  "4.jpg",
  "3.jpg",
  "2.jpg",
  "1.jpg",
];

function Gallery() {
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Container className="gallery" maxWidth="xl">
      <Box sx={{ flexGrow: 1, display: { xs: "flex" } }}>
        <ImageList variant="masonry" cols={matches ? 3 : 1} gap={8}>
          {galleryImages.map((image, index) => (
            <ImageListItemStyled key={index} image={image} />
          ))}
        </ImageList>
      </Box>
    </Container>
  );
}
export default Gallery;

const ImageListItemStyled = ({ image }) => {
  const imageFile = require(`../../images/gallery/${image}`);

  return (
    <ImageListItem>
      <img
        src={`${imageFile}?w=248&fit=crop&auto=format`}
        srcSet={`${imageFile}?w=248&fit=crop&auto=format&dpr=2 2x`}
        alt="Gallery item"
        loading="lazy"
      />
    </ImageListItem>
  );
};
